import { render, staticRenderFns } from "./afterSale.vue?vue&type=template&id=7fe5692d&scoped=true"
import script from "./afterSale.vue?vue&type=script&lang=js"
export * from "./afterSale.vue?vue&type=script&lang=js"
import style0 from "./afterSale.vue?vue&type=style&index=0&id=7fe5692d&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fe5692d",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/godata/pipelines/eShop-Portal-Web-Release-Prod/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7fe5692d')) {
      api.createRecord('7fe5692d', component.options)
    } else {
      api.reload('7fe5692d', component.options)
    }
    module.hot.accept("./afterSale.vue?vue&type=template&id=7fe5692d&scoped=true", function () {
      api.rerender('7fe5692d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/ordercenter/afterSale.vue"
export default component.exports